/**
 * 定义vue混入
 */
export default {
  install(Vue) {
    // 混入
    Vue.mixin({
      computed: {},
      mounted() {
        this.iosInputBack();
      },
      methods: {
        // 解决ios微信里输入框键盘弹起无法回退的问题
        iosInputBack() {
          const ua = navigator.userAgent;
          if (
            /MicroMessenger/i.test(ua) &&
            /(iPhone|iPad|iPod|iOS)/i.test(ua)
          ) {
            const inputArr = document.querySelectorAll('input');
            inputArr.forEach((item) => {
              if (!item.addMixinBlur) {
                item.addMixinBlur = true;
                item.addEventListener('blur', () => {
                  const scrollTop = document.documentElement.scrollTop
                    ? document.documentElement.scrollTop
                    : document.body.scrollTop;
                  document.documentElement.scrollTop = document.body.scrollTop = scrollTop;
                });
              }
            });
          }
        },
      },
    });
  },
};
